import React, { ComponentPropsWithoutRef, memo } from 'react'

interface TextInputProps extends ComponentPropsWithoutRef<'input'> {
  error?: string,
  touched?: boolean,
  title?: string,
  dataList?: string[],
  list?: string
}

const TextInput = ({
  error,
  touched,
  title,
  dataList,
  list,
  ...props
}: TextInputProps) => {

  return(
    <div className="formElements__group">
      {title ? (<label className="formElements__label">{title}</label>): null}
      <input
        className={`w-100 form-control formElements__input formElements--inputText
            ${touched && error ? (
              'formElements__errorBorder'
            ) : ''}
            `}
        {...props}
        list={list}
      /> 

      {dataList ? (
        <datalist id={list}>
          {dataList.map((data) => (
            <option key={data} value={data} />
          ))} 
        </datalist>
      ): null}

      {touched && error ? (
        <div className='formElements__errorText'>{error}</div>
      ) : null}
        <div className="invalid-feedback" />
    </div>
  )
}

export default TextInput